type Props = {};

export default function Footer({}: Props) {
  const onLinkClick = (type: 'insurance-booklet' | 'policy-summary' | 'terms-of-business' | 'our-cover' | 'faqs' | 'contact-us' | 'your-data') => () => {
    switch (type) {
      case 'insurance-booklet':
        window.open('https://files.ripeinsurance.co.uk/SmallBusiness/SCLC/2025/SCLC_15592_Booklet_01_11_25.pdf', '_blank');
        break;
      case 'policy-summary':
        window.open('https://files.ripeinsurance.co.uk/SmallBusiness/SCLC/2025/SCLC_15592_PolicySummary_01_11_25.pdf', '_blank');
        break;
      case 'terms-of-business':
        window.open('https://www.ripeinsurance.co.uk/terms-of-business/', '_blank');
        break;
      case 'our-cover':
        window.open('', '_blank');
        break;
      case 'faqs':
        window.open('https://help.ripeinsurance.co.uk/hc/en-gb/sections/11170519390109-Small-Business', '_blank');
        break;
      case 'contact-us':
        window.open('https://help.ripeinsurance.co.uk/hc/en-gb/requests/new', '_blank');
        break;
      case 'your-data':
        window.open('https://www.ripeinsurance.co.uk/how-we-use-your-data/', '_blank');
        break;
    }
  };
  return (
    <>
      <div className="sclc-hidden lg:sclc-block sclc-h-[130px] sclc-bg-[#2d2926]">
        <div className="sclc-h-[68px]">
          <div className="sclc-w-[1200px] sclc-mx-auto sclc-flex sclc-items-center sclc-justify-center sclc-gap-6 sclc-h-full">
            <div className="sclc-text-[#fff] sclc-text-[14px] sclc-w-[500px]">
              <p className="sclc-text-right sclc-font-proxima-soft sclc-font-bold">USEFUL DOCUMENTS</p>
              <div className="sclc-flex sclc-items-center sclc-justify-end sclc-text-[14px] sclc-text-[#ff8200] sclc-font-proxima-soft">
                <span className="sclc-px-3 sclc-font-proxima-soft sclc-cursor-pointer hover:sclc-opacity-80" onClick={onLinkClick('insurance-booklet')}>
                  Insurance Booklet
                </span>
                <div className="sclc-h-[9px] sclc-w-[1px] sclc-bg-[#85888b]"></div>
                <span className="sclc-px-3 sclc-font-proxima-soft sclc-cursor-pointer hover:sclc-opacity-80" onClick={onLinkClick('policy-summary')}>
                  Policy Summary
                </span>
                <div className="sclc-h-[9px] sclc-w-[1px] sclc-bg-[#85888b]"></div>
                <span className="sclc-pl-3 sclc-font-proxima-soft sclc-cursor-pointer hover:sclc-opacity-80" onClick={onLinkClick('terms-of-business')}>
                  Terms of business
                </span>
              </div>
            </div>
            <div className="sclc-h-full sclc-bg-[#85888b] sclc-w-[1px]"></div>
            <div className="sclc-text-[#fff] sclc-text-[14px] sclc-w-[500px]">
              <p className="sclc-text-left sclc-font-proxima-soft sclc-font-bold">USEFUL INFORMATION</p>
              <div className="sclc-flex sclc-items-center sclc-justify-start sclc-text-[14px] sclc-text-[#ff8200]">
                <span className="sclc-px-3 sclc-font-proxima-soft sclc-cursor-pointer hover:sclc-opacity-80" onClick={onLinkClick('faqs')}>
                  FAQs
                </span>
                <div className="sclc-h-[9px] sclc-w-[1px] sclc-bg-[#85888b]"></div>
                <span className="sclc-px-3 sclc-font-proxima-soft sclc-cursor-pointer hover:sclc-opacity-80" onClick={onLinkClick('contact-us')}>
                  Contact us
                </span>
                <div className="sclc-h-[9px] sclc-w-[1px] sclc-bg-[#85888b]"></div>
                <span className="sclc-px-3 sclc-font-proxima-soft sclc-cursor-pointer hover:sclc-opacity-80" onClick={onLinkClick('your-data')}>
                  How we use your data
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="sclc-bg-white">
          <div className="sclc-py-[15px] xl:sclc-w-[1200px] sclc-mx-auto sclc-px-2 xl:sclc-px-0">
            <p className="sclc-font-proxima-soft sclc-text-[12px] sclc-leading-[1.55] sclc-text-[#85878a] sclc-text-center">
              <span className="sclc-font-bold sclc-font-proxima-soft">© Ripe Thinking Limited {new Date().getFullYear()}</span> Ripe Insurance Services Limited is Authorised and Regulated by the Financial Conduct Authority No.313411. Registered office: One Stockport Exchange, Railway Road, Stockport, United Kingdom, SK1 3SW. Registered in England No 04507332. The insurance is underwritten by Hiscox Insurance Company Ltd.
            </p>
          </div>
        </div>
      </div>
      <div className="sclc-block lg:sclc-hidden sclc-bg-black sclc-pb-4">
        <div className="sclc-h-[120px] sclc-flex">
          <div className="sclc-w-[calc(50%-0.5px)] sclc-inline-block sclc-text-[#fff] sclc-text-[14px] sclc-pr-2 md:sclc-pr-8">
            <p className="sclc-text-right sclc-font-proxima-soft sclc-font-bold sclc-py-3">USEFUL DOCUMENTS</p>
            <div className="sclc-text-right sclc-text-[14px] sclc-leading-[1.43] sclc-text-[#ff8200] sclc-font-proxima-soft sclc-pb-3">
              <p className="sclc-font-proxima-soft sclc-cursor-pointer hover:sclc-opacity-80" onClick={onLinkClick('insurance-booklet')}>
                Insurance Booklet
              </p>
              <p className="sclc-font-proxima-soft sclc-mt-1 sclc-cursor-pointer hover:sclc-opacity-80" onClick={onLinkClick('policy-summary')}>
                Policy Summary
              </p>
              <p className="sclc-font-proxima-soft sclc-mt-1 sclc-cursor-pointer hover:sclc-opacity-80" onClick={onLinkClick('terms-of-business')}>
                Terms of business
              </p>
            </div>
          </div>
          <div className="sclc-h-full md:sclc-w-[1px] sclc-inline-block sclc-bg-[#85888b]"></div>
          <div className="sclc-w-[calc(50%-0.5px)] sclc-inline-block sclc-text-[#fff] sclc-text-[14px] sclc-pl-2 md:sclc-pl-8">
            <p className="sclc-text-left sclc-font-proxima-soft sclc-font-bold sclc-py-3">USEFUL INFORMATION</p>
            <div className="sclc-text-left sclc-text-[14px] sclc-leading-[1.43] sclc-text-[#ff8200] sclc-font-proxima-soft sclc-pb-3">
              <p className="sclc-font-proxima-soft sclc-mt-1">
                <span className="sclc-cursor-pointer hover:sclc-opacity-80" onClick={onLinkClick('faqs')}>
                  FAQs
                </span>
                <span className="sclc-inline-block sclc-h-[9px] sclc-w-[1px] sclc-bg-[#85888b] sclc-mx-3"></span>
                <span className="sclc-cursor-pointer hover:sclc-opacity-80" onClick={onLinkClick('contact-us')}>
                  Contact us
                </span>
              </p>
              <p className="sclc-font-proxima-soft sclc-mt-1 sclc-cursor-pointer hover:sclc-opacity-80" onClick={onLinkClick('your-data')}>
                How we use your data
              </p>
            </div>
          </div>
        </div>
        <div className="sclc-bg-white sclc-px-4 sclc-py-3">
          <p className="sclc-font-proxima-soft sclc-text-[12px] sclc-leading-[1.55] sclc-text-[#85878a] sclc-text-center">
            <span className="sclc-font-bold sclc-font-proxima-soft">© Ripe Thinking Limited {new Date().getFullYear()}</span> Ripe Insurance Services Limited is Authorised and Regulated by the Financial Conduct Authority No.313411. Registered office: One Stockport Exchange, Railway Road, Stockport, United Kingdom, SK1 3SW. Registered in England No 04507332. The insurance is underwritten by Hiscox Insurance Company Ltd.
          </p>
        </div>
      </div>
    </>
  );
}
